import React from "react";
import OnboardingStep from "./OnboardingStep";

const Step1FindBars: React.FC = () => {
  return (
    <OnboardingStep
      className="step1-find-bars"
      title="Step 1: Find Bars"
      description="Discover bars with pool tables near you."
    ></OnboardingStep>
  );
};

export default Step1FindBars;
